import script from "./sms-verify.vue?vue&type=script&lang=ts&setup=true"
export * from "./sms-verify.vue?vue&type=script&lang=ts&setup=true"

import "./sms-verify.vue?vue&type=style&index=0&id=2d2c997f&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2c997f"]])

export default __exports__